export function formatDate(date, opts = {}) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...opts,
  });
}

export function formatDateTime(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTime(date) {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function toIsoLocal(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}`
  );
}

export function getUserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

// --- Date/Time helpers for the split DatePicker + TimeSelect ---------------

const pad = (n) => String(n).padStart(2, '0');

/** Format a Date / ISO string as local "YYYY-MM-DD" (date only). */
export function toLocalDateString(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Format a Date / ISO string as local "HH:MM" (24-hour). */
export function toLocalTimeString(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (isNaN(d.getTime())) return '';
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/**
 * Combine a "YYYY-MM-DD" + "HH:MM" pair into a "YYYY-MM-DD HH:MM:SS" string
 * suitable for Laravel / MySQL `datetime` columns. Returns '' if either
 * piece is missing.
 */
export function combineDateTime(dateStr, timeStr) {
  if (!dateStr || !timeStr) return '';
  return `${dateStr} ${timeStr}:00`;
}

/** Same as combineDateTime but returns an ISO 8601 local string. */
export function combineDateTimeIso(dateStr, timeStr) {
  if (!dateStr || !timeStr) return '';
  return `${dateStr}T${timeStr}:00`;
}

/** Render "HH:MM" as a 12-hour display like "09:30 AM". */
export function formatTime12h(timeStr) {
  if (!timeStr) return '';
  const [hRaw, mRaw] = timeStr.split(':');
  const h = Number(hRaw);
  const m = Number(mRaw);
  if (Number.isNaN(h) || Number.isNaN(m)) return '';
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${pad(hour12)}:${pad(m)} ${period}`;
}

/** Human date label like "Apr 25, 2026" from "YYYY-MM-DD". */
export function formatDateLabel(dateStr) {
  if (!dateStr) return '';
  // Parse as local midnight so timezone doesn't shift the day.
  const [y, mo, d] = dateStr.split('-').map(Number);
  if (!y || !mo || !d) return '';
  return new Date(y, mo - 1, d).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
